export const summitPalette = {
  IconColor: '#000',
  ButtonColor: '#7E45C4',
  PillOneColor: '#7E45C4',
  PillTwoColor:'#E5E5E5',
  FontColor:'#000',
  BackgroundColor:'#fff',
  DisabledColor:'#E1E1E1',
  purpleFont: '#30004A',
  pinkToPurpleGradient: 'linear-gradient(90deg, #DA006A 0%, #72004D 30.06%, #7D1882 56.62%, #240563 100%)',
  greenToYellowGradient: 'linear-gradient(90deg, #21C53E 0%, #B6CC22 100%)',
  yellowToGreenGradient: 'linear-gradient(90deg, #B6CC22 0%, #34C63B 100%)',
  yellow: '#BABF00',
  timerPurple: '#7D177F',
  backgroundComplement: '#F5F5F5',
  backgroundII: '#7E45C4',
  lightPurpleBackground: 'rgba(187, 134, 252, 0.2)',
  cardBorder: '#CCCCCC',
  cardOverlay: 'rgba(255, 237, 237, 0.37)',
  subHeader: '#7D1882',
  countDownContainer: '#D9D9D9'
}